import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import { LIFEMART_PUBLIC_PAGES_ENABLED } from "@/config/featureFlags";
import { Navigate } from "@/lib/router-compat";
import LifeMartStackOffer from "@/pages/LifeMartStackOffer";

// Newly gated 2026-08-06. Note: src/lib/adminReengage.server.ts builds
// re-engagement email CTAs pointing here for LifeMart users -- with this
// gated, clicking that email link now redirects home instead of landing
// on the offer. The email-send logic itself is unaffected, only the
// destination page's availability changed.
export const Route = createFileRoute("/lifemart/stack-offer")({
  head: () => seoHead("/lifemart/stack-offer"),
  component: () => (LIFEMART_PUBLIC_PAGES_ENABLED ? <LifeMartStackOffer /> : <Navigate to="/" replace />),
});
